import { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { LOGIN_REDIRECT_URL } from "../api/configApi";
import Loading from "../commerçant/ui/Loading";

export default function PrivateRoute({ children }) {
  const { user, loading } = useContext(AuthContext);

  useEffect(() => {
    if (!loading && !user) {
      window.location.replace(LOGIN_REDIRECT_URL);
    }
  }, [loading, user]);

  if (loading) {
    return <Loading fullScreen text="Vérification de votre session…" size="lg" />;
  }

  if (!user) {
    return <Loading fullScreen text="Redirection vers la connexion…" variant="dots" />;
  }

  return children;
}